import { SlideDeck } from '@/components/investor';
import { pitchSlides } from '@/content/pitch';

/**
 * Direct-access investor page — deliberately absent from the navigation.
 * Content lives in src/content/pitch.tsx, mirroring docs/investors/pitch.md.
 */
export function PitchDeckPage() {
  return (
    <SlideDeck
      slides={pitchSlides}
      onePagerPath="/one-pager"
      footer="Confidential. Zero paying customers as of this deck; every commercial figure is a management scenario, not contracted revenue."
    />
  );
}
